import { Button } from "@/components/ui/button";
import { ModeToggle } from "@/components/mode-toggle";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { UserCircle } from "lucide-react";
import { adminAuthService } from "@/admin/api/adminAuth.service";

export function Header() {
  const handleLogout = async () => {
    await adminAuthService.logout();
  };

  return (
    <header className="sticky top-0 w-full border-b bg-background">
      <div className="flex h-16 items-center justify-between px-4">
        <h1 className="font-bold text-lg">Ohay Delivery Dashboard</h1>

        <div className="flex items-center gap-2">
          <ModeToggle />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" aria-label="User menu" aria-haspopup="menu">
                <UserCircle className="h-5 w-5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" role="menu">
              <DropdownMenuItem role="menuitem" disabled>Profile</DropdownMenuItem>
              <DropdownMenuItem role="menuitem" disabled>Settings</DropdownMenuItem>
              <DropdownMenuItem role="menuitem" onClick={handleLogout}>Logout</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
